export const containsOnlyDigits = (value: string) => {
  return /^\d+$/.test(value);
};
